import React, { Component } from 'react'
import "./ButtonBanner.css";

import Button from '@material-ui/core/Button';
import ButtonGroup from "@material-ui/core/ButtonGroup";

export default class ButtonBanner extends Component {
    render() {
        return (
            <div class = "button-banner">
                <div class = "button-banner-buttons">
                    <ButtonGroup fullWidth fullHeight size = "large">
                        <Button onClick = {() => {this.props.action(1)}}>About</Button>
                        <Button onClick = {() => {this.props.action(2)}}>Experience</Button>
                        <Button onClick = {() => {this.props.action(3)}}>Projects</Button>
                    </ButtonGroup>
                </div>
            </div>
        )
    }
}
